const { showMobileModeDirective } = require('./show-mobile-mode-directive')
const { editableDirective } = require('./editable-directive')

// console.log('directives/index.js',
//     ' @watch showMobileModeDirective ',
//     showMobileModeDirective)
//export default { showMobileModeDirective }
export default {
  showMobileModeDirective,
  editableDirective
}



// WEBPACK FOOTER //
// ./src/directives/index.js